import React from 'react';
import { NoScheduleIcon } from 'src/client/components/common/icons';

export const NotFound = () => {
  return (
    <>
      <li className="not-found">
        <p className="text-center">この日の仕事が見つかりませんでした</p>
        <div className="mt-12">
          <NoScheduleIcon width={300} margin={'0 auto'} />
        </div>
      </li>
      <style jsx>{`
        .not-found {
          margin-top: 50px;
          display: block;
        }
      `}</style>
    </>
  );
};
